import produce from 'immer'
import * as types from 'Redux/Types/UserManagementTypes'

const initialState = {
  addingUser: false,
  deactivatingUser: false,
  fetchingManagedUsers: false,
  fetchingUserRoles: false,
  registeringManagedUser: false,
  registerManagedUserError: null,
  resendingUserInvite: false,
  managedUsers: [],
  updatingUser: false,
  userRoles: [],
  isUpdatedManagedUsersList: false,
}

const addUser = (draft) => {
  draft.addingUser = true
}

const addUserFailed = (draft) => {
  draft.addingUser = false
}

const addUserSucceeded = (draft) => {
  draft.addingUser = false
}

const deactivateUsers = (draft) => {
  draft.deactivatingUser = true
}

const deactivateUsersFailed = (draft) => {
  draft.deactivatingUser = false
}

const deactivateUsersSucceeded = (draft) => {
  draft.deactivatingUser = false
}

const fetchManagedUsers = (draft) => {
  draft.fetchingManagedUsers = true
}

const fetchManagedUsersFailed = (draft) => {
  draft.fetchingManagedUsers = false
}

const fetchManagedUsersSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingManagedUsers = false
  draft.managedUsers = data
  draft.nextManagedUsers = next
  draft.previousManagedUsers = previous
  draft.isUpdatedManagedUsersList = true
}

const fetchUserRoles = (draft) => {
  draft.fetchingUserRoles = true
}

const fetchUserRolesFailed = (draft) => {
  draft.fetchingUserRoles = false
}

const fetchUserRolesSucceeded = (draft, payload) => {
  draft.fetchingUserRoles = false
  draft.userRoles = payload
}

const registerManagedUser = (draft) => {
  draft.registeringManagedUser = true
}

const registerManagedUserFailed = (draft, payload) => {
  draft.registeringManagedUser = false
  draft.registerManagedUserError = payload
}

const registerManagedUserSucceeded = (draft) => {
  draft.registeringManagedUser = false
}

const resendUserInvite = (draft) => {
  draft.resendingUserInvite = true
}

const resendUserInviteFailed = (draft) => {
  draft.resendingUserInvite = false
}

const resendUserInviteSucceeded = (draft) => {
  draft.resendingUserInvite = false
}

const updateManagedUser = (draft) => {
  draft.updatingUser = true
}

const updateManagedUserFailed = (draft) => {
  draft.updatingUser = false
}

const updateManagedUserSucceeded = (draft) => {
  draft.updatingUser = false
}

const userManagementReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.ADD_USER:
        return addUser(draft)

      case types.ADD_USER_FAILED:
        return addUserFailed(draft)

      case types.ADD_USER_SUCCEEDED:
        return addUserSucceeded(draft)

      case types.DEACTIVATE_USERS:
        return deactivateUsers(draft)

      case types.DEACTIVATE_USERS_FAILED:
        return deactivateUsersFailed(draft)

      case types.DEACTIVATE_USERS_SUCCEEDED:
        return deactivateUsersSucceeded(draft)

      case types.FETCH_MANAGED_USERS:
        return fetchManagedUsers(draft)

      case types.FETCH_MANAGED_USERS_FAILED:
        return fetchManagedUsersFailed(draft)

      case types.FETCH_MANAGED_USERS_SUCCEEDED:
        return fetchManagedUsersSucceeded(draft, payload)

      case types.FETCH_USER_ROLES:
        return fetchUserRoles(draft)

      case types.FETCH_USER_ROLES_FAILED:
        return fetchUserRolesFailed(draft)

      case types.FETCH_USER_ROLES_SUCCEEDED:
        return fetchUserRolesSucceeded(draft, payload)

      case types.REGISTER_MANAGED_USER:
        return registerManagedUser(draft)

      case types.REGISTER_MANAGED_USER_FAILED:
        return registerManagedUserFailed(draft, payload)

      case types.REGISTER_MANAGED_USER_SUCCEEDED:
        return registerManagedUserSucceeded(draft)

      case types.RESEND_USER_INVITE:
        return resendUserInvite(draft)

      case types.RESEND_USER_INVITE_FAILED:
        return resendUserInviteFailed(draft)

      case types.RESEND_USER_INVITE_SUCCEEDED:
        return resendUserInviteSucceeded(draft)

      case types.UPDATE_MANAGED_USER:
        return updateManagedUser(draft)

      case types.UPDATE_MANAGED_USER_FAILED:
        return updateManagedUserFailed(draft)

      case types.UPDATE_MANAGED_USER_SUCCEEDED:
        return updateManagedUserSucceeded(draft)

      // no default
    }
  })
}

export default userManagementReducer
